const EnumSeniority = {
  JUNIOR: "JUNIOR",
  MEDIOR: "MEDIOR",
  SENIOR: "SENIOR",
};

export default EnumSeniority;
